<script setup>
import NclModal from "@/components/NclModal.vue";
</script>
<template>
  <ncl-modal title="Information">
    The Nowcasting Lab is an automated code-database-website environment. It
    generates nowcasts and one-quarter ahead forecasts for quarterly GDP growth
    of various countries. For this, several nowcasting models and large datasets
    are used. The projections are updated daily.<br /><br />

    The Nowcasting Lab project is experimental in nature. It does NOT provide
    official projections of the KOF Swiss Economic Institute. Rather, we see the
    Nowcasting Lab as a platform that tests GDP short-term projection models in
    a live out-of-sample setting and provides a transparent account of the
    outcomes (see
    <a
      class="external-link"
      href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4353052"
      >Kronenberg et al., 2023</a
    >). We hope that you see the potential of the Nowcasting Lab as a
    "transparent laboratory".<br /><br />

    We are very happy about your feedback. Also, we are very interested in
    research collaborations to extend and improve the Nowcasting Lab. Contact us
    under
    <a
      class="external-link"
      href="mailto:nowcastinglab@kof.ethz.ch"
      target="_blank"
      >nowcastinglab@kof.ethz.ch</a
    >.
  </ncl-modal>
</template>
